<template>
  <!--
  <div class="text-xs-right">
    <v-btn fab @click.stop="deleteAction" v-if="!isNew" dark error :loading="loading" :disabled="disable" v-tooltip:top="getDeleteTooltip">
      <v-icon>{{ getDeleteIcon }}</v-icon>
    </v-btn>
    <v-btn fab @click.stop="saveAction" dark success :loading="loading" :disabled="disable" v-tooltip:top="getSaveTooltip">
      <v-icon>{{ getSaveIcon }}</v-icon>
    </v-btn>
  </div>
-->
  <v-flex>
    <v-divider />
    <v-card-actions>
      <!-- Error display -->
      <v-text-field
        class="ft-hide-input pt-0"
        :error-messages="errorMessages"
        :disabled="disabled"
      />
      <v-spacer />
      <!-- buttons -->
      <v-btn
        v-if="deleteAction"
        :loading="loading"
        :disabled="deleteDisabled || disabled"
        color="error"
        text
        @click="deleteAction"
      >
        {{ deleteText || 'Delete' }}
      </v-btn>
      <v-btn
        v-if="saveAction"
        :loading="loading"
        :disabled="saveDisabled || disabled"
        color="primary"
        text
        @click="saveAction"
      >
        {{ saveText || 'Save' }}
      </v-btn>
      <slot />
    </v-card-actions>
  </v-flex>
</template>

<script>
export default {
  name: 'ItemEditorButtons',
  props: {
    deleteIcon: [String, Boolean],
    saveIcon: [String, Boolean],
    deleteText: [String, Boolean],
    saveText: [String, Boolean],
    deleteAction: [Function, Boolean],
    saveAction: [Function, Boolean],
    type: String,
    isNew: Boolean,
    loading: Boolean,
    saveDisabled: Boolean,
    deleteDisabled: Boolean,
    disabled: Boolean,
    errorMessages: {
      type: Array,
      default: () => {return []}
    }
  },
  computed: {
    getDeleteIcon () {
      return this.deleteIcon || 'delete_forever'
    },
    getSaveIcon () {
      return this.saveIcon || 'check'
    },
    getDeleteTooltip () {
      return {html: this.deleteText || 'Delete ' + this.type}
    },
    getSaveTooltip () {
      return {html: this.saveText || this.isNew ? 'Create ' + this.type : 'Update ' + this.type}
    }
  }
}
</script>
